import { Component, OnInit, Input } from '@angular/core';
import { FilterNavigationService } from '../filter-navigation.service';

@Component({
  selector: 'app-selected-filters',
  templateUrl: './selected-filters.component.html',
  styleUrls: ['./selected-filters.component.scss']
})
export class SelectedFiltersComponent implements OnInit {

  @Input() searchedFilters;
  @Input() filters;
  @Input() filtersSelected;
  @Input() filtersSelectedNoDeselect;
  @Input() searchType;

  @Input() more;

  constructor(public filterService: FilterNavigationService) { }

  ngOnInit() {}

  getDropdownName(filter, key) {
    let returnval;
    const name = filter.ddData.filter(function(ddData) {
      return ddData.Key === key;
    });
    if (name.length > 0) {
      returnval = name[0].Value;
    }

    return returnval;
  }

  removeFilters(more?) {
    this.filters.forEach((obj) => {
      if (obj.name !== 'sortType') {
        if (more) {
          if (obj.type === 'checkbox-list' && obj.movetoMore) {
            obj.ddData.forEach((option) => {
              if (option.Key === 'people' || option.Key === 'places') {
                option.Checked = true;
              } else {
                option.Checked = false;
              }
            });
          } else if (obj.movetoMore) {
            obj.checked = false;
            obj.selected = undefined;
          }
        } else {
          if (obj.type === 'checkbox-list') {
            obj.ddData.forEach((option) => {
              if (option.Key === 'people' || option.Key === 'places') {
                option.Checked = true;
              } else {
                option.Checked = false;
              }
            });
          } else {
            obj.checked = false;
            obj.selected = undefined;
          }
        }
      }
    });
    if (!this.more) {
      this.filterService.updateFilters(this.searchType);
    }
  }

  removeFilter(e, name) {
    this.filters.forEach(function(obj) {
      if (obj.name === name) {
        if (obj.type === 'checkbox') {
          obj.checked = false;
        } else if (obj.type === 'dropdown') {
          obj.selected = undefined;
        }
        return;
      }
    });
    if (this.more) {
      e.stopPropagation();
    } else {
      this.filterService.updateFilters(this.searchType);
    }

  }

  removeFilterCheckboxList(e, name, key) {
    this.filters.forEach(function(obj) {
      if (obj.name === name && obj.type === 'checkbox-list') {
        const option = obj.ddData.filter(o => o.Key === key);
        option[0].Checked = false;
      }
    });

    if (this.more) {
      e.stopPropagation();
    } else {
      this.filterService.updateFilters(this.searchType);
    }
  }

}
